export const MUTATION_PROGRESS_INIT = 'MUTATION_PROGRESS_INIT';
export const MUTATION_PROGRESS_NONE = 'MUTATION_PROGRESS_NONE';
export const MUTATION_PROGRESS_ERROR = 'MUTATION_PROGRESS_ERROR';
export const MUTATION_PROGRESS_OK = 'MUTATION_PROGRESS_OK';
export const MUTATION_PROGRESS_IN_PROGRESS = 'MUTATION_PROGRESS_IN_PROGRESS';

export const MUTATION_CONFIG_LOGO2_SET = 'MUTATION_CONFIG_LOGO2_SET';

export const MUTATION_AUTH_INIT = 'MUTATION_AUTH_INIT';
export const MUTATION_AUTH_SET = 'MUTATION_AUTH_SET';

export const MUTATION_CONFIGURATION_SET = 'MUTATION_CONFIGURATION_SET';
export const MUTATION_ORDER_SET = 'MUTATION_ORDER_SET';
export const MUTATION_PHONE_SET = 'MUTATION_PHONE_SET';
export const MUTATION_EMAIL_SET = 'MUTATION_EMAIL_SET';
export const MUTATION_VISIT_DATE_SET = 'MUTATION_VISIT_DATE_SET';

export const MUTATION_CATALOG_SET = 'MUTATION_CATALOG_SET';
export const MUTATION_SET_COMPAT_FILTER = 'MUTATION_SET_COMPAT_FILTER';
export const MUTATION_CATALOG_ITEM_SET_QNT = 'MUTATION_CATALOG_ITEM_SET_QNT';
export const MUTATION_CATALOG_ITEM_SET_PRICE = 'MUTATION_CATALOG_ITEM_SET_PRICE';

export const MUTATION_IMAGES_SET = 'MUTATION_IMAGES_SET';
export const MUTATION_CONFIG_STATIC_IMAGES = 'MUTATION_CONFIG_STATIC_IMAGES';
export const MUTATION_SET_IMAGES_VERSION = 'MUTATION_SET_IMAGES_VERSION';

export const MUTATION_SHOPPING_CART_INIT = 'MUTATION_SHOPPING_CART_INIT';
export const MUTATION_SHOPPING_CART_CLEAR = 'MUTATION_SHOPPING_CART_CLEAR';
export const MUTATION_SHOPPING_CART_ITEM_SET_QNT = 'MUTATION_SHOPPING_CART_ITEM_SET_QNT';
export const MUTATION_SHOPPING_CART_ITEM_SET_PRICE = 'MUTATION_SHOPPING_CART_ITEM_SET_PRICE'; 

export const MUTATION_CARDS_SET_CARDS_LIST = 'MUTATION_CARDS_SET_CARDS_LIST';
export const MUTATION_CARDS_SET_INIT = 'MUTATION_CARDS_SET_INIT';
export const MUTATION_CARDS_SET_CARD_HISTORY = 'MUTATION_CARDS_SET_CARD_HISTORY';
export const MUTATION_CARDS_SET_CARD_TARIFICATIONS = 'MUTATION_CARDS_SET_CARD_TARIFICATIONS';
export const MUTATION_CARDS_SET_CARD_SUBSCRIPTIONS = 'MUTATION_CARDS_SET_CARD_SUBSCRIPTIONS';

